/* eslint newline-before-return: "error" */
import { enableOrDisableRole } from '../../Api/request/role';
import UseAxios from '../../Api/http/http';
import {
  ENABLE_DISABLE_ROLE_DIALOG,
  AUTHENTICATION_FAILED,
} from '../../Constants/strings';
import { STATUS_CODES } from '../../Api/resources/statusCodes';

export const handleDialogSubmit = async (
  data,
  setRows,
  setIsDialogOpen,
  handleSnackbar,
  setIsEdit,
) => {
  // Operations to be performed on enabling/disabling role
  let isActive = data.is_active || data.isActive;
  isActive = Number(isActive) ? 0 : 1;

  const roleData = {
    role_id: data.role_id || data.id,
    is_active: isActive,
    last_updated_by: data.last_updated_by,
  };

  try {
    const response = await UseAxios(enableOrDisableRole(roleData));
    // API call to enable/disable role
    if (response.data.status !== STATUS_CODES.SUCCESS) {
      const errorStatus = response.data.response.status;

      handleDialogClose(setIsDialogOpen, setIsEdit);
      let snackbarMessage = ENABLE_DISABLE_ROLE_DIALOG.OOPS_TRY_AGAIN;
      if (errorStatus === STATUS_CODES.INVALID_REQUEST) {
        snackbarMessage = ENABLE_DISABLE_ROLE_DIALOG.CANNOT_DISABLE;
      } else if (errorStatus === STATUS_CODES.UNAUTHORIZED) {
        snackbarMessage = AUTHENTICATION_FAILED;
      }
      handleSnackbar(snackbarMessage, 'warning', 'enable-disable-warning-snackbar');
      throw new Error('Failed to enable/disable role');
    }

    setRows((prevRows) =>
      prevRows.map((row) => {
        if (roleData.role_id === row.id) {
          row.isActive = roleData.is_active; // Update the isActive value of updated row
        }
        // Close the dialog, after successful API response
        handleDialogClose(setIsDialogOpen, setIsEdit);
        const message_1 = roleData.is_active
          ? ENABLE_DISABLE_ROLE_DIALOG.ENABLE.RESPONSE_SUCCESS
          : ENABLE_DISABLE_ROLE_DIALOG.DISABLE.RESPONSE_SUCCESS;
        handleSnackbar(message_1, 'success', 'enable-disable-success-snackbar');

        return row;
      }),
    );
  } catch (error) {
    console.error(error);
  }
};

export const handleDialogClose = (setIsDialogOpen, setIsEdit) => {
  // Close the dialog
  setIsDialogOpen(false);
  setIsEdit(false);
};
